export function createResizeObserver(callback) {
  return {
    observer: new ResizeObserver(callback),
    observe(element) {
      if (this.observer) {
        this.observer.observe(element);
      }
    },
    disconnect() {
      if (this.observer) {
        this.observer.disconnect();
        delete this.observer;
      }
    },
  };
}
